import React from "react";

import { USER_ACTIONS } from "Bands/types";
import { DeleteUserEntityModal } from "Bands/containers";
import { copy } from "shared/assets";
import { useDispatch } from "react-redux";
import { deleteUserAddress } from "Bands/state";

const { userAddress: addressCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const DeleteUserAddressModal: React.FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(deleteUserAddress(id));
  };

  return (
    <DeleteUserEntityModal
      type="address"
      action={USER_ACTIONS.deleteUserAddress}
      successMessage={addressCopy.messages.deleted}
      handleDelete={handleDelete}
      handleClose={handleClose}
    />
  );
};
